import React, { useState, memo } from 'react'
import PropTypes from 'prop-types'
import { List, Map } from 'immutable'
import { formatPrice, QTY_SELECT, getTotal, getSize } from '@aytm/app/swidget/questions/components/sh/functions'

import popupStyle from '@aytm/app/swidget/questions/styles/sh/popup.module.scss'
import ImageGallery from '@aytm/lib/rfd-ui/components/advanced/image-gallery'
// import PopupImage from '@aytm/app/swidget/questions/components/sh/popupImage'
import PopupImage from '@aytm/app/swidget/base/components/PopupImage.tsx'
import Select from '@aytm/lib/rfd-ui/components/basic/select'
import { asBoolean } from '@aytm/lib/immutable/ImmutableModel'
import Button from '@aytm/lib/rfd-ui/components/basic/button'
import LightBox from '@aytm/lib/rfd-ui/components/basic/light-box'
import { hapticEffects } from '@aytm/app/swidget/base/lib/hapticEffects'

const preventEverything = event => {
  event.preventDefault()
  event.stopPropagation()
}

const onFocus = () => {
  hapticEffects.soft()
}

ProductPopup.propTypes = {
  questionSchema: PropTypes.instanceOf(Map).isRequired,
  item: PropTypes.instanceOf(Map).isRequired,
  locale: PropTypes.instanceOf(Map).isRequired,
  answer: PropTypes.instanceOf(Map).isRequired,
  enableMagnify: PropTypes.bool,
  fullScreen: PropTypes.bool,
  emulatedMobile: PropTypes.bool,
  onClosePopup: PropTypes.func,
  onPictureClick: PropTypes.func,
  onAction: PropTypes.func
}

export function ProductPopup(props) {
  const {
    questionSchema,
    item,
    answer,
    enableMagnify,
    emulatedMobile,
    onClosePopup,
    locale,
    onAction,
    fullScreen,
    onPictureClick
  } = props
  const answerQty = answer.getIn(['answers', item.get('id'), 'count'])
  const findability =
    'find' == questionSchema.get('mode_type') ||
    (1 == questionSchema.get('max_cart_size') && !questionSchema.get('shopping_cart'))

  const maxQty = findability ? null : questionSchema.get('max_qty_per_product')
  const maxCartSize = findability ? null : questionSchema.get('max_cart_size')
  const maxMoney = findability ? null : questionSchema.get('max_money_spent')
  const total = getTotal(answer)
  const itemPrice = item.get('discounted_price') || item.get('price')
  const size = getSize(answer)

  const [picture, setPicture] = useState(null)
  const [volume, setVolume] = useState(item.getIn(['view3d', 'default']))
  const [qty, setQty] = useState(1)

  const gallery = (item.get('gallery') || List([])).insert(0, item.get('image'))
  const src = volume
    ? item.getIn(['view3d', 'file_url'])
    : picture || item.getIn(['currentPicture', 'original_url']) || item.getIn(['image', 'original_url'])
  const altText = src === item.getIn(['image', 'original_url']) ? item.getIn(['image', 'alt_text']) : undefined
  const onSelectQty = selectedQty => {
    setQty(selectedQty.get('value'))
    hapticEffects.selection()
  }

  const onButtonClick = () => {
    onAction(qty)
  }

  const onContainerClick = event => {
    if (!event.target.src) onClosePopup()
  }

  const onSetPicture = (value, index) => {
    setPicture(value)
    setVolume('view3d' == value)
    onPictureClick && 'function' === typeof onPictureClick && onPictureClick(index + 1)
  }

  const popupContent = () => (
    <div
      className={`${popupStyle.popup} ` + (fullScreen ? `${popupStyle.fixed} ` : ``)}
      data-testid="SW-SH-Popup"
      onMouseMove={preventEverything}
      onMouseUp={preventEverything}
      onMouseDown={preventEverything}
    >
      <div className={popupStyle.closeButton} onClick={onClosePopup}>
        <i className="icon-aytmfd-close" />
      </div>
      {(item.get('gallery') || item.get('view3d')) && (
        <ImageGallery
          imageList={item.get('view3d') ? gallery.insert(1, item.get('view3d').set('original_url', 'view3d')) : gallery}
          onChange={onSetPicture}
          value={
            volume
              ? 1
              : item.get('currentPicture')
                ? item.getIn(['currentPicture', 'index']) + (item.get('view3d') ? 2 : 1)
                : 0
          }
        />
      )}
      {/*<div className={popupStyle.viewContainer}>*/}
      <div
        className={`${popupStyle.imageContainer} ${
          !fullScreen && item.get('gallery') && item.get('gallery').size > 1 ? popupStyle.think : ''
        }`}
        onClick={onContainerClick}
        data-testid="SW-SH-Popup-Image"
      >
        <PopupImage
          src={src}
          altText={altText}
          enableMagnify={enableMagnify}
          emulatedMobile={emulatedMobile}
          volume={volume}
        />
      </div>
      <div className={popupStyle.popupButtons} data-testid="SW-SH-Popup-Buttons">
        {questionSchema.get('show_name') && (
          <div>
            <span
              className={popupStyle.name}
              dangerouslySetInnerHTML={{
                __html: item.get('text')
              }}
              data-testid="SW-SH-Popup-Header"
            ></span>
          </div>
        )}
        {!questionSchema.get('hide_price') && (
          <div>
            {item.get('discounted_price') ? (
              <span
                className={popupStyle.discountedPrice}
                data-testid="SW-SH-Popup-DPrice"
                dangerouslySetInnerHTML={{
                  __html: formatPrice(item.get('price'), questionSchema.get('price_mask'), true)
                }}
              ></span>
            ) : (
              ''
            )}
            <span
              className={popupStyle.price}
              data-testid="SW-SH-Popup-Price"
              dangerouslySetInnerHTML={{
                __html: formatPrice(
                  item.get('discounted_price') || item.get('price'),
                  questionSchema.get('price_mask'),
                  true
                )
              }}
            />
            {item.get('units') && (
              <span dangerouslySetInnerHTML={{ __html: item.get('units') }} className={popupStyle.units} />
            )}
          </div>
        )}
        <Select
          className={popupStyle.combo}
          newIcon={true}
          options={QTY_SELECT.filter(
            v =>
              (!maxQty || v.get('value') <= maxQty - answerQty) &&
              (!maxCartSize || v.get('value') + size <= maxCartSize) &&
              (!maxMoney || v.get('value') * itemPrice + total <= maxMoney)
          )}
          width={80}
          placeholder="1"
          value={qty}
          onSelect={onSelectQty}
          onFocus={onFocus}
          showSelected={true}
          filterOptions={false}
          optionsMaxHeight={fullScreen ? 80 : 'inherit'}
          disabled={findability}
          data-testid="SW-SH-Popup-Select"
          // disabled={
          //   (asBoolean(maxQty) && maxQty <= answerQty + 1) ||
          //   (asBoolean(maxCartSize) && maxCartSize <= size + 1) ||
          //   (asBoolean(maxMoney) && maxMoney <= total + itemPrice)
          // }
        />
        <Button
          label={locale.getIn(['sh', 'addToCart'])}
          data-testid="SW-SH-Popup-AddButton"
          onAction={onButtonClick}
          className={popupStyle.button}
          disabled={
            (asBoolean(maxQty) && maxQty <= answerQty) ||
            (asBoolean(maxCartSize) && maxCartSize <= size) ||
            (asBoolean(maxMoney) && maxMoney < total + itemPrice)
          }
        />
      </div>
      {/*</div>*/}
    </div>
  )

  return questionSchema.get('fullscreen') ? <LightBox>{popupContent()}</LightBox> : popupContent()
}

export default memo(
  ProductPopup,
  (prevProps, nextProps) =>
    prevProps.questionSchema === nextProps.questionSchema &&
    prevProps.item === nextProps.item &&
    prevProps.answer === nextProps.answer &&
    prevProps.enableMagnify === nextProps.enableMagnify &&
    prevProps.fullScreen === nextProps.fullScreen &&
    prevProps.onClosePopup === nextProps.onClosePopup &&
    prevProps.locale === nextProps.locale &&
    prevProps.onAction === nextProps.onAction
)
